'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

interface OperatingHourListProps {
  dayTextList: string[];
}

const DayTextList = ({ dayTextList }: OperatingHourListProps) => (
  <ul className="flex flex-1 flex-col gap-8">
    {dayTextList.map((dayText) => (
      <li key={dayText} className="typo-body4">
        <span>{dayText}</span>
      </li>
    ))}
  </ul>
);

const SearchParamAwareOperatingHourList = ({
  dayTextList,
}: OperatingHourListProps) => {
  const searchParams = useSearchParams();

  if (searchParams.get('isEmergency') === 'true')
    return <p className="typo-body4">24시간</p>;

  return <DayTextList dayTextList={dayTextList} />;
};

// useSearchParams를 자체 Suspense로 감싸 페이지 전체의 CSR bailout을 막는다.
export const OperatingHourList = ({ dayTextList }: OperatingHourListProps) => (
  <Suspense fallback={<DayTextList dayTextList={dayTextList} />}>
    <SearchParamAwareOperatingHourList dayTextList={dayTextList} />
  </Suspense>
);
